const MAX_MOQT_PRIORITY = 0xff;

declare const subscriberPriorityBrand: unique symbol;
declare const publisherPriorityBrand: unique symbol;

export type MoqtSubscriberPriority = number & { readonly [subscriberPriorityBrand]: true };
export type MoqtPublisherPriority = number & { readonly [publisherPriorityBrand]: true };

function moqtPriority(value: number, field: string): number {
	if (!Number.isInteger(value) || value < 0 || value > MAX_MOQT_PRIORITY) {
		throw new RangeError(`${field} must be an integer in [0, ${MAX_MOQT_PRIORITY}], got ${value}`);
	}
	return value;
}

/** Validate a protocol-native MOQT subscriber priority without transforming it. */
export function moqtSubscriberPriority(value: number): MoqtSubscriberPriority {
	return moqtPriority(value, "MOQT subscriber priority") as MoqtSubscriberPriority;
}

/** Validate a protocol-native MOQT publisher priority without transforming it. */
export function moqtPublisherPriority(value: number): MoqtPublisherPriority {
	return moqtPriority(value, "MOQT publisher priority") as MoqtPublisherPriority;
}

/** Shared media subscription policy on MOQT's native lower-number-wins scale. */
export const MOQT_SUBSCRIBER_PRIORITY = Object.freeze({
	catalog: moqtSubscriberPriority(0),
	/**
	 * @deprecated A repair FETCH's SUBSCRIBER_PRIORITY is derived per request
	 * from the catalog source and repair priorities (draft-ramadan-moq-fec
	 * §11.4.5), not a player constant. Use the `subscriberPriority` that
	 * `@blockcast/mmt-container`'s `wireRepairFetch` puts on each
	 * `RepairFetchRequest` (`repairFetchSubscriberPriority`).
	 */
	deadlineRepair: moqtSubscriberPriority(0),
	audio: moqtSubscriberPriority(1),
	video: moqtSubscriberPriority(2),
	/**
	 * @deprecated See `deadlineRepair`: use the request's catalog-derived
	 * `RepairFetchRequest.subscriberPriority` (draft-ramadan-moq-fec §11.4.5).
	 */
	backgroundRepair: moqtSubscriberPriority(3),
});

/** Publisher priority bands from draft-ramadan-moq-fec section 10. */
export const MOQT_PUBLISHER_PRIORITY = Object.freeze({
	catalog: moqtPublisherPriority(32),
	source: moqtPublisherPriority(128),
	repair: moqtPublisherPriority(240),
});
